import {getFooterData} from '@/api/home'

const state = {
  footer: {
    icp_b: '',
    address: '',
    mobile: '',
    email: '',
    address_usa: ''
  },
  logo: '',
  width: 0,
  categories: []
}

const mutations = {
  SET_FOOTER: (state, footer) => {
    state.footer = footer
  },
  SET_LOGO: (state, logo) => {
    state.logo = logo
  },
  SET_WIDTH: (state, width) => {
    state.width = width
  },
  SET_CATEGORIES: (state, categories) => {
    state.categories = categories
  }
}

const actions = {
  getFooter ({ commit }) {
    return new Promise((resolve, reject) => {
      getFooterData().then(data => {
        const {footer, logo, categories} = data
        commit('SET_FOOTER', footer)
        commit('SET_LOGO', logo)
        commit('SET_CATEGORIES', categories)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  setWidth ({commit}, width) {
    commit('SET_WIDTH', width)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js